import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23745743"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DexDataTable = _resolveComponent("DexDataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_DexDataTable, {
    value: _ctx.substitutions,
    loading: _ctx.loading,
    class: "p-datatable-sm editable-cells-table",
    autoLayout: true,
    columnResizeMode: "fit",
    editMode: "cell",
    onCellEditInit: _ctx.onCellEdit,
    onCellEditComplete: _ctx.onCellComplete,
    paginator: true,
    rows: _ctx.tableListPagination.pageSize,
    paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
    rowsPerPageOptions: [25,50,100],
    currentPageReportTemplate: '{first} ' + _ctx.$t('Squeeze.General.To') + ' {last} ' + _ctx.$t('Squeeze.General.Of') + ' {totalRecords}  ',
    scrollable: true,
    scrollHeight: "flex",
    onPage: _ctx.onChangePage
  }, {
    loading: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1)
    ]),
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.Locators.Tabs.Substitution') })), 1)
    ]),
    paginatorstart: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _ctx.$t('Squeeze.General.NewEntry'),
        type: "button",
        icon: "mdi mdi-plus",
        class: "p-button",
        onClick: _ctx.onNewEntryClick
      }, null, 8, ["label", "onClick"])
    ]),
    paginatorend: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: "orgChar",
        header: _ctx.$t('Squeeze.Locators.Tabs.OrgChar'),
        class: "column-char"
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.orgChar), 1)
        ]),
        editor: _withCtx((data) => [
          _createVNode(_component_InputText, {
            maxLength: "1",
            modelValue: data.data.orgChar,
            "onUpdate:modelValue": ($event: any) => ((data.data.orgChar) = $event),
            onDblclick: ($event: any) => (_ctx.openEditDialog(data.data)),
            onKeyup: ($event: any) => (_ctx.changeEventInInput(data.data))
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onDblclick", "onKeyup"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "newChar",
        header: _ctx.$t('Squeeze.Locators.Tabs.NewChar'),
        class: "column-char"
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.newChar), 1)
        ]),
        editor: _withCtx((data) => [
          _createVNode(_component_InputText, {
            maxLength: "1",
            modelValue: data.data.newChar,
            "onUpdate:modelValue": ($event: any) => ((data.data.newChar) = $event),
            onDblclick: ($event: any) => (_ctx.openEditDialog(data.data)),
            onKeyup: ($event: any) => (_ctx.changeEventInInput(data.data))
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onDblclick", "onKeyup"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, { style: {"min-width":"10rem","text-align":"right"} }, {
        body: _withCtx((substitutions) => [
          (_ctx.isInvalidSubstitution(substitutions.data))
            ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(_ctx.$t('Forms.Val.MissingRequiredFields', { fieldOne: _ctx.$t('Squeeze.Locators.Tabs.OrgChar'), fieldTwo: _ctx.$t('Squeeze.Locators.Tabs.NewChar')})), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_Column, { style: {"min-width":"7rem","max-width":"7rem","text-align":"right"} }, {
        body: _withCtx((substitutions) => [
          _withDirectives(_createVNode(_component_Button, {
            icon: "mdi mdi-pencil-outline",
            class: "p-button-lg p-button-rounded p-button-success p-button-text",
            onClick: ($event: any) => (_ctx.openEditDialog(substitutions.data))
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('Squeeze.Locators.Edit'),
              void 0,
              { bottom: true }
            ]
          ]),
          _withDirectives(_createVNode(_component_Button, {
            icon: "mdi mdi-delete-outline",
            class: "p-button-lg p-button-rounded p-button-danger p-button-text",
            onClick: ($event: any) => (_ctx.openDeleteDialog(substitutions.data))
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('Squeeze.Validation.Buttons.Delete'),
              void 0,
              { bottom: true }
            ]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value", "loading", "onCellEditInit", "onCellEditComplete", "rows", "currentPageReportTemplate", "onPage"]))
}